module.exports = __webpack_public_path__ + "static/media/no-image.b3159f4d.jpeg";